import { useEffect, useState } from 'react'
import { MenuComponent } from '../../_metronic/assets/ts/components'
import { KTSVG } from '../../_metronic/helpers'
import { useQueryRequest } from './request'
import { useQueryResponse } from './response'
import { useSearchParams } from 'react-router-dom'
import { getProjectOfferAll } from '../company-module/projectOffer/api'
/**
 * OfferFilter Component
 *
 * Provides a filter UI for offers, allowing users to filter data by selecting a project offer.
 *
 * Features:
 * - Loads available offers from API
 * - Syncs filter state with URL parameters
 * - Updates global query state for data filtering
 * - Allows resetting and applying offer filters
 * - Displays currently applied offer filter
 */
const OfferFilter = () => {
    const { updateState } = useQueryRequest()
    const { isLoading } = useQueryResponse()

    const [offer_id, setOfferId] = useState('') // Applied offer
    const [selectedOfferId, setSelectedOfferId] = useState('') // Temporary selection
    const [offer, setOffer] = useState([])

    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        MenuComponent.reinitialization()

        getProjectOfferAll()
            .then((res) => {
                setOffer(res.data)
            })
            .catch((err) => {
                console.error('Error loading offers:', err)
            })

        const offerParam = searchParams.get('offer_id')
        if (offerParam) {
            setOfferId(offerParam)
            setSelectedOfferId(offerParam)
        }
    }, [])

    const resetData = () => {
        setOfferId('')
        setSelectedOfferId('')
        setSearchParams('')
        updateState({ filter: undefined })
    }

    const filterData = () => {
        setOfferId(selectedOfferId) // Commit selection
        const params = {}
        if (selectedOfferId) params.offer_id = selectedOfferId

        setSearchParams(params)
        updateState({
            filter: params,
        })
    }

    return (
        <>
            {/* Show applied filter only */}
            {offer_id && (
                <div className='me-3 d-flex align-items-center'>
                    <span className='badge badge-light-primary fw-semibold fs-7 px-4 py-5'>
                        Selected Offer :&nbsp;
                        <span className='text-dark'>
                            {offer.find((item) => item.id === Number(offer_id))?.offer_name || 'N/A'}
                        </span>
                    </span>
                </div>
            )}

            {/* Filter Trigger Button */}
            <button
                disabled={isLoading}
                type='button'
                className='btn btn-light-primary me-3'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
            >
                <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                Filter
            </button>

            {/* Filter Dropdown Menu */}
            <div className='menu menu-sub menu-sub-dropdown w-500px w-md-525px' data-kt-menu='true'>
                <div className='px-7 py-5'>
                    <div className='fs-5 text-dark fw-semibolder'>Filter by Offer</div>
                </div>
                <div className='separator border-gray-200'></div>

                <div className='px-7 py-5'>
                    <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-semibold fs-6'>Select Offer</label>
                        <div className='col-lg-8 fv-row'>
                            <select
                                className='form-select form-select-solid fw-semibold'
                                onChange={(e) => setSelectedOfferId(e.target.value)}
                                value={selectedOfferId}
                            >
                                <option value=''>Select</option>
                                {offer.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.offer_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className='separator border-gray-200'></div>

                <div className='px-7 py-5 d-flex justify-content-end'>
                    <button
                        type='button'
                        disabled={isLoading}
                        onClick={resetData}
                        className='btn btn-light btn-active-light-primary fw-semibold me-2 px-6'
                        data-kt-menu-dismiss='true'
                    >
                        Reset
                    </button>
                    <button
                        type='button'
                        onClick={filterData}
                        className='btn btn-primary fw-semibold px-6'
                        data-kt-menu-dismiss='true'
                    >
                        Apply
                    </button>
                </div>
            </div>
        </>
    )
}

export { OfferFilter }
